import React, {FC} from 'react';

import {factory} from './Section/factory';
import Sections from './Section/Sections';
import Header from './Header';
import {Result} from './query';
import {ReportSettings} from './reportTypes';
import ResultsList from './ResultsList';
import Section from './Section';
import {Sharing} from './Sharing';
import Summary from './Summary';
import {Configs} from './types';

import * as styles from './styles.module.scss';

type ReportsCoreProps = ReportSettings & {
	cfgs: Configs
	data: Result
}

export const ReportsCore: FC<ReportsCoreProps> = ({
	cfgs,
	data,
	...rest
}) => {
	const dexa = data?.reports?.dexa;
	if (!dexa) {
		return null;
	}
	const settings: ReportSettings = rest;

	const sections = cfgs.sections
		.filter((s) => {
			if (s.exclude !== 'voice') return true;

			// Obey explicit configuration always
			if (settings.voice === true) {
				return true;
			} else if (settings.voice === false) {
				return false;
			}

			// Hide if report being generated as sample or for non-owner
			if (settings.sample || !dexa.owner) {
				return false;
			}

			// By default, show to the user
			return true;
		})
		.map((s) => ({
			section: s,
			component: factory(data, s),
		}))
		.filter(s => (
			s.component
		))
		.map(({section, component}, i) => (
			<Section {...section} key={i}>
				{component}
			</Section>
		));

	return (
		<div className={styles.wrapper}>
			<Sharing cache={dexa.id} owner={dexa.owner && !settings.sample} />
			<Header {...cfgs.header} {...settings} />
			<ResultsList data={dexa.summary} />
			<Summary data={dexa} sections={cfgs.sections} />
			<Sections>{sections}</Sections>
		</div>
	);
};
